<template>
  <div class="cshell" :class="`cshell--${mode}`" data-testid="cabinet-shell">
    <!-- First: the screens' bottom sheets teleport INTO this portal, so it must exist before the slot mounts them —
         after the slot, a sheet mounted on the first render found no target and the next route change crashed in
         Vue's unmount («Cannot read properties of null (reading 'type')»), leaving the home on screen. -->
    <Teleport to="body">
      <div id="sheet-portal" />
    </Teleport>
    <slot v-if="mode !== 'phone'" name="nav" />
    <main class="cshell__main hide-scrollbar">
      <slot />
    </main>
    <slot v-if="mode === 'phone'" name="nav" />
  </div>
</template>

<script setup lang="ts">
import type { LayoutMode } from '@/composables/useLayout';

/**
 * The client cabinet's frame (docs/cabinet-redesign/05_ПЛАН_ВНЕДРЕНИЯ.md §2.2): navigation on the left from 700 px,
 * a bottom tab bar below that. Content is full width here — each screen centres its own 640/880 column.
 */
defineProps<{ mode: LayoutMode }>();
</script>

<style scoped lang="scss">
.cshell {
  display: flex;
  height: var(--app-height, 100dvh);
  width: 100%;
  background: var(--cream);
  color: var(--text);
  overflow: hidden;
}

.cshell--phone { flex-direction: column; }

.cshell__main {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

.cshell--phone > :deep(nav) { flex: 0 0 auto; }
</style>
